module.exports = __webpack_public_path__ + "static/media/ic_message_disable.1b23e928.svg";